import React from "react"

const IconCheckmark = () => (
  <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.35478 17.3756C6.73255 17.3756 6.11033 17.135 5.63637 16.6562L0.775261 11.7455C-0.175087 10.7854 -0.175087 9.23365 0.775261 8.27361C1.72561 7.31356 3.26172 7.31356 4.21207 8.27361L7.35478 11.4484L17.7892 0.907534C18.7395 -0.0525112 20.2756 -0.0525112 21.226 0.907534C22.1763 1.86758 22.1763 3.41936 21.226 4.37941L9.07318 16.6562C8.59922 17.135 7.977 17.3756 7.35478 17.3756Z" fill="white"/>
  </svg>
)

export default IconCheckmark